import React from "react";
import LoadableComponent from "./loadable";
import { IProps } from "./interfaces";

export default (props: IProps) => <LoadableComponent {...props} />;
